import React, { useState } from "react";
import api from "../../../api/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PostForm from "./PostForm";

const AdminAddPost = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const createPost = async (data) => {
    setLoading(true);

    try {
      await api.post("/posts", data);
      toast.success("Post created successfully");
      navigate("/admin/posts");
    } catch (err) {
      toast.error(err.cleanMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      <h1 className="text-3xl font-black text-[#0b6b1d] mb-6">
        Add New Post
      </h1>

      <PostForm onSubmit={createPost} loading={loading} />
    </section>
  );
};

export default AdminAddPost;